// import { ExtraModel, ID, Response } from "../../../../../_metronic/helpers"

import { ExtraModel, ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Extra = {
  id?: ID
  name?: string
  car_name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type ExtrasQueryResponse = Response<Array<ExtraModel>>

export const initialExtra: Extra = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}
